module.exports = __webpack_public_path__ + "img/power.357b46e7.svg";